<div class="section-header" mat-dialog-title>
  <mat-icon class="section-icon">edit</mat-icon>
  <span class="section-title">edit question and answer</span>
  <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form [formGroup]="qaForm" class="qa-form">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Question</mat-label>
      <textarea matInput formControlName="question" rows="3" placeholder="Enter your question"></textarea>
      @if (qaForm.get('question')?.hasError('required')) {
        <mat-error>
          Question is required
        </mat-error>
      }
      @if (qaForm.get('question')?.hasError('minlength')) {
        <mat-error>
          Question must be at least 3 characters
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Answer</mat-label>
      <textarea matInput formControlName="answer" rows="5" placeholder="Enter the answer"></textarea>
      @if (qaForm.get('answer')?.hasError('required')) {
        <mat-error>
          Answer is required
        </mat-error>
      }
      @if (qaForm.get('answer')?.hasError('minlength')) {
        <mat-error>
          Answer must be at least 3 characters
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Category (Optional)</mat-label>
      <input matInput formControlName="category" placeholder="Enter category">
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Video ID (Optional)</mat-label>
      <input matInput formControlName="videoId" placeholder="Enter video ID">
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!qaForm.valid">
    Update Q&A
  </button>
</mat-dialog-actions>